/**
 * Local placeholder images using data URIs (inline SVGs)
 * These never depend on external services and always work offline
 */

// Generic placeholder with customizable text
const createPlaceholderSVG = (text = '', size = 200, bgColor = '#e0e0e0', textColor = '#888') => {
    const escapedText = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const fontSize = Math.min(size / 8, 16);
    const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
            <rect fill="${bgColor}" width="${size}" height="${size}"/>
            <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-family="system-ui, sans-serif" font-size="${fontSize}" fill="${textColor}">${escapedText}</text>
        </svg>
    `.trim().replace(/\s+/g, ' ');
    return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

// Person silhouette placeholder for profile pics
const createPersonPlaceholderSVG = (size = 200, bgColor = '#e0e0e0', iconColor = '#bbb') => {
    const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
            <rect fill="${bgColor}" width="${size}" height="${size}"/>
            <circle cx="${size/2}" cy="${size*0.35}" r="${size*0.18}" fill="${iconColor}"/>
            <ellipse cx="${size/2}" cy="${size*0.85}" rx="${size*0.32}" ry="${size*0.25}" fill="${iconColor}"/>
        </svg>
    `.trim().replace(/\s+/g, ' ');
    return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

// Product/image placeholder
const createImagePlaceholderSVG = (size = 200, bgColor = '#f5f5f5', iconColor = '#ccc') => {
    const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
            <rect fill="${bgColor}" width="${size}" height="${size}"/>
            <rect x="${size*0.25}" y="${size*0.3}" width="${size*0.5}" height="${size*0.4}" rx="4" fill="${iconColor}"/>
            <circle cx="${size*0.38}" cy="${size*0.42}" r="${size*0.06}" fill="${bgColor}"/>
            <polygon points="${size*0.3},${size*0.65} ${size*0.45},${size*0.5} ${size*0.55},${size*0.58} ${size*0.7},${size*0.45} ${size*0.7},${size*0.65}" fill="${bgColor}"/>
        </svg>
    `.trim().replace(/\s+/g, ' ');
    return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

// Pre-generated common placeholders
export const PLACEHOLDER_PROFILE = createPersonPlaceholderSVG(200);
export const PLACEHOLDER_PROFILE_LOADING = createPlaceholderSVG('Carregant…', 200, '#ddd', '#999');
export const PLACEHOLDER_PROFILE_NO_PHOTO = createPersonPlaceholderSVG(200);
export const PLACEHOLDER_IMAGE = createImagePlaceholderSVG(200);
export const PLACEHOLDER_IMAGE_SMALL = createImagePlaceholderSVG(100);
export const PLACEHOLDER_IMAGE_MEDIUM = createImagePlaceholderSVG(150);

// Helper functions for dynamic creation
export { createPlaceholderSVG, createPersonPlaceholderSVG, createImagePlaceholderSVG };

